// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@flip/XDL/types";
import { css } from "styled-components";

export const fontConfig = {
    url: "https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap",
    weight: {
        light: 300,
        regular: 400,
        semiBold: 500,
        bold: 700,
        extraBold: 900,
    },
    fontFamily: "'Roboto', sans-serif",
};

export const headingsFontConfig = {
    url: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap",
    weight: {
        light: 300,
        regular: 400,
        semiBold: 500,
        bold: 700,
        extraBold: 800,
    },
    fontFamily: "'Open Sans', sans-serif",
};

export default {
    fontFamilyImportUrl: "",
    body: {
        size: "16px",
        weight: fontConfig.weight.regular,
        fontFamily: fontConfig.fontFamily,
        lineHeight: "26px",
    },
    p: {
        size: "16px",
        weight: fontConfig.weight.regular,
        fontFamily: fontConfig.fontFamily,
        lineHeight: "26px",
        css: css`
            margin-bottom: 16px;
            letter-spacing: 0;
        `,
    },
    h1: {
        size: "32px",
        weight: headingsFontConfig.weight.bold,
        fontFamily: headingsFontConfig.fontFamily,
        lineHeight: "40px",
        css: css`
            margin-bottom: 24px;
            letter-spacing: 0;
        `,
    },
    h2: {
        size: "28px",
        weight: headingsFontConfig.weight.bold,
        fontFamily: headingsFontConfig.fontFamily,
        lineHeight: "34px",
        css: css`
            margin-bottom: 20px;
            letter-spacing: 0;
        `,
    },
    h3: {
        size: "24px",
        weight: headingsFontConfig.weight.bold,
        fontFamily: headingsFontConfig.fontFamily,
        lineHeight: "30px",
        css: css`
            margin-bottom: 16px;
            letter-spacing: 0;
        `,
    },
    h4: {
        size: "20px",
        weight: headingsFontConfig.weight.bold,
        fontFamily: headingsFontConfig.fontFamily,
        lineHeight: "26px",
        css: css`
            margin-bottom: 24px;
            letter-spacing: 0;
        `,
    },
    h5: {
        size: "18px",
        weight: headingsFontConfig.weight.bold,
        fontFamily: headingsFontConfig.fontFamily,
        lineHeight: "22px",
        css: css`
            margin-bottom: 22px;
            letter-spacing: 0;
        `,
    },
    h6: {
        size: "16px",
        weight: headingsFontConfig.weight.bold,
        fontFamily: headingsFontConfig.fontFamily,
        lineHeight: "22px",
        css: css`
            margin-bottom: 8px;
            letter-spacing: 0;
        `,
    },
    headerPrimary: {
        forwardAs: "p",
        size: "24px",
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        transform: "uppercase",
    },
    headerSecondary: {
        forwardAs: "p",
        size: "15px",
        fontFamily: fontConfig.fontFamily,
        transform: "uppercase",
        weight: 800,
    },
    headerTertiary: {
        forwardAs: "p",
        size: "15px",
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        transform: "uppercase",
    },
    legend: {
        forwardAs: "span",
        size: "12px",
        lineHeight: "14px",
        weight: fontConfig.weight.regular,
        color: "text.main",
        css: css`
            text-transform: none;
            margin-bottom: 8px;
            letter-spacing: 0;
            padding-inline-start: 0;
            padding-inline-end: 0;
        `,
    },
} as xBaseTheme["typography"];
